import React, { useEffect, createElement } from 'react';
const META_PIXEL_ID = '1322788416056310';
type FacebookPixel = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
type MetaWindow = Window & {
  _fbq?: FacebookPixel;
  fbq?: FacebookPixel;
};
export function MetaPixel() {
  useEffect(() => {
    const metaWindow = window as MetaWindow;
    if (!metaWindow.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        fbq.queue.push(args);
      } as FacebookPixel;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      metaWindow.fbq = fbq;
      metaWindow._fbq = fbq;
      if (!document.getElementById('meta-pixel-script')) {
        const script = document.createElement('script');
        script.id = 'meta-pixel-script';
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
    }
    metaWindow.fbq('init', META_PIXEL_ID);
    metaWindow.fbq('track', 'PageView');
  }, []);
  return null;
}